import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { CapsuleButton } from "../_components";
import { BudgetsUiAlertsActions } from "../_actions/BudgetsUiAlertsActions";
import { LicensesActions } from "../_actions/LicensesActions";
import { genericActions } from "../_helpers/ActionErrorWrapper";
import { getLicenseActions } from "./licenseStates";

export function LicenseActionButtons({ license, licenseType, onDone }) {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { canRenew, canReactivate, canCancel } = getLicenseActions(license, licenseType);

    function run(action, successMessage) {
        dispatch(action({ uid: license.uid })).then(() => {
            dispatch(BudgetsUiAlertsActions.showSuccessAlert(t(successMessage)));
            onDone?.();
        }).catch((error) => {
            dispatch(genericActions.errorCatch(error));
        });
    }

    return (
        <div className="btn-group" role="group">
            {canRenew && (
                <CapsuleButton
                    onClick={() => run(LicensesActions.renewLicense, "mod_budgets_renew_license_success")}
                    text={t("mod_budgets_licenses_table_action_renew")}
                />
            )}
            {canReactivate && (
                <CapsuleButton
                    onClick={() => run(LicensesActions.reactivateLicense, "mod_budgets_reactivate_license_success")}
                    text={t("mod_budgets_licenses_table_action_reactivate")}
                />
            )}
            {canCancel && (
                <>
                    <div className="ml-1"></div>
                    <CapsuleButton
                        onClick={() => run(LicensesActions.cancelLicense, "mod_budgets_cancel_license_success")}
                        text={t("mod_budgets_licenses_table_action_cancel")}
                        style={"DANGER"}
                    />
                </>
            )}
        </div>
    );
}
